import React from 'react';

import { DataContext } from '@/context/data';

export const useDataContext = (): any => {
  return React.useContext<any>(DataContext);
};
